import { createFileRoute } from '@tanstack/react-router';

import { filterState, TabularPageLoadingLayout } from '@/_containers';
import { getAwardsQueryOptions } from '@/_pages/awards/api-service';

export const Route = createFileRoute('/_private/awards/')({
  validateSearch: filterState.parse,
  staticData: { isFullWidth: true },
  loader: (opts) => opts.context.queryClient.ensureQueryData(getAwardsQueryOptions()),
  pendingComponent: () => <TabularPageLoadingLayout numberOfColumns={5} />,
});
